/**
 * PageLoading — shared Suspense fallback used by App.js's outer boundary
 * (catches lazy layouts like PopupLayout) and each Layout's inner boundary
 * (catches lazy page navigations).
 *
 * Extracted from App.js during T2-B (Path C Phase 1) so all three layouts
 * (Layout, PortalLayout, PopupLayout) can use the same fallback without
 * duplicating markup.
 */
export default function PageLoading () {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="text-4xl mb-4">⚖️</div>
        <div className="text-gray-500">Loading…</div>
      </div>
    </div>
  )
}
